import type { VisitableGraph } from '../interface';
import type { EID, NID, Nodes } from '../types';
import { ControlFlow } from './ControlFlow';
import { depthFirstSearch, type DFSVisitor } from './depthFirstSearch';

export function topologicalSort<G, N, E>(
  graph: VisitableGraph<G, N, E>,
  opts?: { roots: Nodes; rootsOnly: boolean }
): NID[] {
  const visitor = new TopologicalSortVisitor<G, N, E>();
  return depthFirstSearch(graph, visitor, opts);
}

class TopologicalSortVisitor<G, N, E> implements DFSVisitor<G, N, E, NID[]> {
  private _order: NID[] = [];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  backEdge(graph: VisitableGraph<G, N, E>, edge: EID): ControlFlow<NID[]> {
    throw new Error('Not a DAG');
  }

  finishNode(graph: VisitableGraph<G, N, E>, node: NID): ControlFlow<NID[]> {
    this._order.push(node);
    return ControlFlow.continue();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  finish(graph: VisitableGraph<G, N, E>): NID[] {
    return this._order.reverse();
  }
}
